<div class="flex flex-col h-full">
  <div>
    <h1>Produktlister</h1>
  </div>
  <div class="flex gap-10">
    <div style="width:500px;">
      <p-panel>
        <app-produktliste-form />
      </p-panel>
    </div>
    @if (plService.paramsValid()) {
      <div style="width:500px;">
        <p-panel>
          <app-produktliste-result />
        </p-panel>
      </div>
    }
  </div>
</div>
